import scrollLock from 'scroll-lock';
import { gsap } from 'gsap';

export default class ScrollLocking {
	constructor() {

		// Dom elements
		this.navButton = document.querySelector('[data-menu-toggle]');

		document.addEventListener('disable-scroll', () => {
			this.lock();
		});

		document.addEventListener('enable-scroll', () => {
			this.unlock();
		});
	}

	lock() {
		gsap.set(this.navButton, {
            right: parseInt(getComputedStyle(this.navButton).right)+scrollLock.getCurrentPageScrollBarWidth()+'px' // set temp scrollbar adjusment
        });
        scrollLock.disablePageScroll();
	}

	unlock() {
		scrollLock.clearQueueScrollLocks();
		scrollLock.enablePageScroll();
        this.navButton.style.removeProperty('right'); // reset temp scrollbar adjusment
	}

}